import React, { useRef } from 'react';
import css from './CalendarList.module.css';
import { StackedColumn } from '../../../../../containers';
import { useDebugLogger, useOutsideAlerter } from '@mchs/web-core';
import { CalendarEvent } from '../calendarEvent';
import { CalendarDef } from './calendarDef';
import { availableCalendars } from './calenedarListDefs';
import { ImageAlignment } from '../../../../../../models';
import { ImageTextLink } from '../../../imageTextLink';

interface CalendarListProps {
  calendarEvent: CalendarEvent;
  onClosePopup: () => void;
}

const CalendarList: React.FC<CalendarListProps> = (
  props: CalendarListProps
) => {
  const poppupRef = useRef(null);
  useOutsideAlerter(poppupRef, props.onClosePopup);

  const debugLogger = useDebugLogger();

  const onCalendarClick = (
    calendarDef: CalendarDef,
    calendarEvent: CalendarEvent
  ) => {
    debugLogger.log('CalendarList', `Clicked ${calendarDef.displayName}`);
    calendarDef.actionFunc(calendarEvent);
    props.onClosePopup();
  };

  return (
    <div ref={poppupRef} className={css.calendarListPopup}>
      <StackedColumn>
        {availableCalendars.map((calendarDef) => (
          <ImageTextLink
            key={calendarDef.displayName}
            imageSource={calendarDef.logo}
            caption={calendarDef.displayName}
            onClick={() => onCalendarClick(calendarDef, props.calendarEvent)}
            imageAlignment={ImageAlignment.Left}
          />
        ))}
      </StackedColumn>
    </div>
  );
};

export default CalendarList;
